import { render, staticRenderFns } from "./UIButton.vue?vue&type=template&id=8b28bf28&scoped=true"
import script from "./UIButton.vue?vue&type=script&lang=js"
export * from "./UIButton.vue?vue&type=script&lang=js"
import style0 from "./UIButton.vue?vue&type=style&index=0&id=8b28bf28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b28bf28",
  null
  
)

export default component.exports